import { render, staticRenderFns } from "./YoutubeVideoPlayer.vue?vue&type=template&id=6ed2ce23&scoped=true&"
import script from "./YoutubeVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./YoutubeVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeVideoPlayer.vue?vue&type=style&index=0&id=6ed2ce23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed2ce23",
  null
  
)

export default component.exports